import { render, staticRenderFns } from "./TripSettings.vue?vue&type=template&id=23a3c5ab"
import script from "./TripSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripSettings.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports